import React, { useEffect, useContext, useState } from "react";
import { DatePicker, Select, TimePicker } from "antd";
import {
  TRANSPORTATION,
  TRANSPORTATION_LOCATIONS,
} from "./transportationConstants";
import { AppContext } from "../../context";
import { openkit } from "../../library/database";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import { searchTransportation } from "./searchTransportation";
import { setFilterOptions } from "./setFilterOptions";

function TransportationFilter({ setProducts }) {
  const info = useContext(AppContext);
  const [fromLocations, setFromLocations] = useState(TRANSPORTATION_LOCATIONS);
  const [toLocations, setToLocations] = useState(TRANSPORTATION_LOCATIONS);
  const [typeOptions, setTypeOptions] = useState([]);
  const [amenitiesOptions, setAmenitiesOptions] = useState([]);

  useEffect(() => {
    (async () => setFilterOptions(info, setTypeOptions, setAmenitiesOptions))();
  }, []);

  useEffect(() => {
    (async () => {
      let transportation = await searchTransportation(info);
      setProducts(transportation);
    })();
  }, [info.transportation]);

  function handleChange(type, value) {
    if (type === "from") {
      // remove location from 'to'
      setToLocations(
        TRANSPORTATION_LOCATIONS.filter((loc) => loc.value !== value)
      );
    }
    if (type === "to") {
      // remove location from 'fom'
      setFromLocations(
        TRANSPORTATION_LOCATIONS.filter((loc) => loc.value !== value)
      );
    }
    info.setTransportation({ ...info.transportation, [type]: value });
  }

  return (
    <div style={{ display: "flex", flexWrap: "wrap" }}>
      <div style={{ display: "block", marginRight: 10 }}>
        <Select
          placeholder={info.t("origin")}
          options={fromLocations}
          style={{ width: FIELD_WIDTHS.L, display: "block" }}
          value={info.transportation.from}
          onChange={(value) => handleChange("from", value)}
          allowClear
          bordered={false}
        />
        <Select
          placeholder={info.t("destination")}
          options={toLocations}
          style={{ width: FIELD_WIDTHS.L }}
          value={info.transportation.to}
          onChange={(value) => handleChange("to", value)}
          allowClear
          bordered={false}
        />
      </div>
      <div style={{ marginRight: 10 }}>
        <div>
          <Select
            placeholder={info.t("type")}
            options={typeOptions}
            style={{ width: FIELD_WIDTHS.L }}
            value={info.transportation.type}
            onChange={(value) => handleChange("type", value)}
            allowClear
            bordered={false}
          />
        </div>
        <div>
          <Select
            placeholder={info.t("extras")}
            options={amenitiesOptions}
            mode="multiple"
            style={{ width: FIELD_WIDTHS.L, marginLeft: 10 }}
            value={info.transportation.amenities}
            onChange={(value) => handleChange("amenities", value)}
            allowClear
            bordered={false}
            showArrow={true}
          />
        </div>
      </div>
      <div style={{ marginRight: 10 }}>
        <div>
          <DatePicker
            placeholder={info.t("date")}
            value={info.transportation?.date}
            onChange={(value) => handleChange("date", value)}
            allowClear
            style={{ width: FIELD_WIDTHS.L }}
            bordered={false}
          />
        </div>
        <div>
          <TimePicker
            placeholder={info.t("time")}
            format="HH:mm"
            minuteStep={10}
            showNow={false}
            disabledHours={() => [0, 1, 2, 3, 4, 5, 6]}
            value={info.transportation?.time}
            onChange={(value) => handleChange("time", value)}
            allowClear
            style={{ width: FIELD_WIDTHS.L }}
            bordered={false}
          />
        </div>
      </div>
    </div>
  );
}

export default TransportationFilter;
